var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrans7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 28,
    r: 27.5,
    fill: "#EDEDED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_332_4808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 45.5C37.165 45.5 45 37.665 45 28C45 18.335 37.165 10.5 27.5 10.5C17.835 10.5 10 18.335 10 28C10 37.665 17.835 45.5 27.5 45.5Z",
    fill: "#F15249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1577 35.8943L29.5978 45.3343C37.5473 44.3959 43.8407 38.1577 44.8344 30.2082L35.3391 20.7129L20.1577 35.8943Z",
    fill: "#AD0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7808 31.864C36.5537 32.6368 36.5537 33.9617 35.7808 34.7346L34.2351 36.2804C33.4622 37.0532 32.1373 37.0532 31.3644 36.2804L19.2193 24.1352C18.4464 23.3624 18.4464 22.0375 19.2193 21.2646L20.8202 19.6636C21.5931 18.8908 22.918 18.8908 23.6909 19.6636L35.7808 31.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3769 25.4053L24.9053 29.8769L31.3643 36.2807C32.1371 37.0535 33.4621 37.0535 34.2349 36.2807L35.8359 34.6797C36.6087 33.9068 36.6087 32.5819 35.8359 31.8091L29.3769 25.4053Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3644 19.7193C32.1373 18.9464 33.4622 18.9464 34.2351 19.7193L35.836 21.3202C36.6089 22.0931 36.6089 23.418 35.836 24.1909L23.6357 36.2808C22.8628 37.0537 21.5379 37.0537 20.765 36.2808L19.2193 34.7351C18.4464 33.9622 18.4464 32.6373 19.2193 31.8644L31.3644 19.7193Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_332_4808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(10 10.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrans7);
export default __webpack_public_path__ + "static/media/trans7.196a8c1900247a8cd99a61606cdaf484.svg";
export { ForwardRef as ReactComponent };